// removed by extract-text-webpack-plugin
module.exports = {"container":"fjgTeU2YwcqjIVxf0-TbM","buttons":"_3XrnAVRn-AB_RWfQN6CB0j","button":"_2gtU1W-upJuCAdukF63qxU"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Main/styles.css
// module id = 2955
// module chunks = 0